import { put } from "redux-saga/effects";
import { Creators as MessagesCreators } from "../ducks/messages";

export function* clearMessagesOnChangePage() {
  yield put(MessagesCreators.clearMessages());
}



// WEBPACK FOOTER //
// ./src/store/sagas/messages.js